module.exports = __webpack_public_path__ + "img/saludmaterna.2983064b.png";